import { IMPRESSION_ACTIONS } from "@cart-client/analytics/constants/Action";
import { SCREEN_NAME } from "@cart-client/analytics/constants";
import { CLICK_ACTIONS } from "@cart-client/analytics/constants/Action";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionAddCakeMessagePill = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
    objectValue: string,
): void => {
    impressionEvent({
        action: IMPRESSION_ACTIONS.IMPRESSION_ADD_CAKE_MESSAGE_PILL,
        category: SCREEN_NAME.CHECKOUT,
        context: context,
        label: objectValue,
    });
};

export const clickAddCakeMessagePill = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context: string,
    objectValue: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_ADD_CAKE_MESSAGE_PILL,
        context: context,
        label: objectValue,
    });
};

export const impressionBottomHalfCard = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
    objectValue: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_HALF_CARD_CAKE_BUTTON,
        context: context,
        label: objectValue,
    });
};

export const impressionMessageBottomHalfCard = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    context: string,
    objectValue: string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_BOTTOM_HALF_CARD,
        context: context,
        label: objectValue,
    });
};

export const clickCloseBottomHalfCard = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context: string,
    objectValue: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_HALF_CARD_CAKE_BUTTON,
        context: context,
        label: objectValue,
    });
};

export const clickCloseBottomAddMsgHalfCard = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    context: string,
    objectValue: string,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_ADD_MESSAGE_HALF_CARD,
        context: context,
        label: objectValue,
    });
};
